import { render, staticRenderFns } from "./ClientActivityView.vue?vue&type=template&id=20d3856d&scoped=true&"
import script from "./ClientActivityView.vue?vue&type=script&lang=js&"
export * from "./ClientActivityView.vue?vue&type=script&lang=js&"
import style0 from "./ClientActivityView.vue?vue&type=style&index=0&id=20d3856d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d3856d",
  null
  
)

export default component.exports